import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import { css as _css } from "styled-components";
import _styled from "styled-components";
var _excluded = ["show"],
  _excluded2 = ["className"],
  _excluded3 = ["visible"],
  _excluded4 = ["className"];
var _templateObject, _templateObject2, _templateObject3;
import React from "react";
import { SelectArrows } from "@styled-icons/entypo/SelectArrows";
import { Eye } from "@styled-icons/fa-regular/Eye";
import { EyeSlash } from "@styled-icons/fa-regular/EyeSlash";
import { Box } from "atomic-layout";
import ReactDatePicker from "react-datepicker";
import { colors } from "../shared/styles";
import "react-datepicker/dist/react-datepicker.css";
var hasValue = _css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n"])), colors.plain);
var baseInputStyle = _css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tdisplay: block;\n\tbox-sizing: border-box;\n\theight: 40px;\n\tline-height: 40px;\n\tcolor: ", ";\n\tborder: 1px solid ", ";\n  border-radius: 6px;\n\tbackground-color: ", ";\n\ttext-align: left;\n\tpadding-left: 8px;\n\tpadding-right: 8px;\n\twidth: 100%;\n"])), colors.primaryBlue, colors.grayRegular, colors.plain);
var baseInputPsuedoStyle = _css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t&:disabled {\n\t\tcursor: not-allowed;\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n\t&:focus {\n\t\toutline: none;\n\t\tbackground-color: ", ";\n\t}\n  &:-webkit-autofill,\n  &:-webkit-autofill:hover, \n  &:-webkit-autofill:focus {\n    -webkit-text-fill-color: ", ";\n    -webkit-box-shadow: 0 0 0px 1000px ", " inset;\n  }\n"])), colors.primaryBlue, colors.plain, colors.plain, colors.primaryBlue, colors.plain);
export var Input = _styled.input.attrs(function (props) {
  var _props$type, _props$placeholder, _props$autocomplete;
  return {
    type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "text",
    placeholder: (_props$placeholder = props.placeholder) !== null && _props$placeholder !== void 0 ? _props$placeholder : "",
    autocomplete: (_props$autocomplete = props.autocomplete) !== null && _props$autocomplete !== void 0 ? _props$autocomplete : ""
  };
}).withConfig({
  displayName: "Input",
  componentId: "sc-1njatub-0"
})(["", " &:not(:placeholder-shown){", "}", ""], baseInputStyle, hasValue, baseInputPsuedoStyle);
export var TextArea = _styled.textarea.attrs(function (props) {
  var _props$rows, _props$cols;
  return {
    rows: (_props$rows = props.rows) !== null && _props$rows !== void 0 ? _props$rows : 5,
    cols: (_props$cols = props.cols) !== null && _props$cols !== void 0 ? _props$cols : 50
  };
}).withConfig({
  displayName: "Input__TextArea",
  componentId: "sc-1njatub-1"
})(["box-sizing:border-box;color:", ";border:1px solid ", ";background-color:", ";text-align:left;padding-left:8px;padding-right:8px;font-size:14px;&:disabled{cursor:not-allowed;background-color:initial;color:", ";background-color:initial;}"], colors.primaryGray, colors.grayRegular, colors.plain, colors.grayRegular);
var EyeToggle = React.forwardRef(function (_ref, ref) {
  var show = _ref.show,
    props = _objectWithoutProperties(_ref, _excluded);
  return show ? /*#__PURE__*/React.createElement(EyeSlash, Object.assign({
    ref: ref
  }, props)) : /*#__PURE__*/React.createElement(Eye, Object.assign({
    ref: ref
  }, props));
});
var _StyledEyeToggle = _styled(EyeToggle).withConfig({
  displayName: "Input___StyledEyeToggle",
  componentId: "sc-1njatub-2"
})(["margin-left:-28px;color:", ";"], function (p) {
  return p.$_css2;
});
export var Password = React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    show = _React$useState2[0],
    setShow = _React$useState2[1];
  return /*#__PURE__*/React.createElement(Box, {
    flex: true,
    alignItems: "center",
    className: className
  }, /*#__PURE__*/React.createElement(Input, Object.assign({
    ref: ref,
    type: show ? "text" : "password"
  }, props)), /*#__PURE__*/React.createElement(_StyledEyeToggle, {
    show: show,
    onClick: function onClick() {
      return setShow(function (prev) {
        return !prev;
      });
    },
    size: 16,
    $_css2: colors.primaryGray
  }));
});
export var OtherLabel = _styled.label.withConfig({
  displayName: "Input__OtherLabel",
  componentId: "sc-1njatub-3"
})(["color:", ";box-sizing:border-box;min-width:0px;width:100%;height:18px;font-size:14px;line-height:18px;font-weight:40;display:flex;align-items:content;margin:0px;"], colors.primaryBlue);
export var Checkbox = _styled.input.attrs({
  type: "checkbox"
}).withConfig({
  displayName: "Input__Checkbox",
  componentId: "sc-1njatub-4"
})(["height:18px;width:18px;margin:0px 8px 0px 0px;border:1px solid ", ";"], colors.grayRegular);
export var Switch = _styled.input.attrs({
  type: "checkbox"
}).withConfig({
  displayName: "Input__Switch",
  componentId: "sc-1njatub-5"
})(["height:24px;width:60px;background:", ";cursor:pointer;border-radius:20px;display:inline-block;-webkit-appearance:none;margin:0;&:focus{outline:none;}&::before{content:\"\";display:inline-block;border-radius:50%;height:16px;width:16px;background:", ";margin-top:4px;margin-left:", ";transition:margin 0.3s ease-in 0s;}&::after{position:absolute;display:inline-block;font-family:\"Open Sans\",sans-serif;vertical-align:top;margin-top:3px;margin-left:", ";font-weight:100;font-size:12px;color:", ";transition:margin 0.3s ease-in 0s;}", ";"], function (props) {
  return props.checked ? colors.secondaryBlueLight : colors.grayRegular;
}, colors.plain, function (props) {
  return props.checked ? "39.5px" : "4.5px";
}, function (props) {
  return props.checked ? "-41px" : "8px";
}, colors.plain, function (props) {
  if (props.checked) {
    return '&::after { content: "ON"; }';
  } else {
    return '&::after { content: "OFF"; }';
  }
});
export var Radio = _styled.input.attrs({
  type: "radio"
}).withConfig({
  displayName: "Input__Radio",
  componentId: "sc-1njatub-6"
})(["height:18px;width:18px;margin:0px 8px 0px 0px;border:1px solid ", ";"], colors.grayRegular);
export var Label = _styled.label.withConfig({
  displayName: "Input__Label",
  componentId: "sc-1njatub-7"
})(["color:", ";box-sizing:border-box;min-width:0px;width:100%;font-size:", "px;line-height:", "px;font-weight:", ";display:flex;margin:0px;"], function (props) {
  var _props$color;
  return (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : colors.primaryBlue;
}, function (props) {
  var _props$fontSize;
  return (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : 12;
}, function (props) {
  var _props$fontSize2;
  return ((_props$fontSize2 = props.fontSize) !== null && _props$fontSize2 !== void 0 ? _props$fontSize2 : 12) + 1;
}, function (props) {
  var _props$fontWeight;
  return (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : 400;
});
export var SelectPlaceholder = React.forwardRef(function (_ref3, ref) {
  var visible = _ref3.visible,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement("option", Object.assign({
    ref: ref,
    disabled: true,
    hidden: !visible,
    style: {
      display: visible !== null && visible !== void 0 ? visible : "none"
    },
    value: ""
  }, props));
});
export var UISelect = React.forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(Box, {
    flex: true,
    alignItems: "center",
    className: className
  }, /*#__PURE__*/React.createElement(_StyledSelect, Object.assign({
    ref: ref
  }, props, {
    required: true
  })), /*#__PURE__*/React.createElement(_StyledSelectArrows, {
    size: 16,
    $_css3: colors.primaryGray
  }));
});
export var DatePicker = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ReactDatePicker, Object.assign({
    ref: ref
  }, props, {
    autoComplete: "off",
    customInput: /*#__PURE__*/React.createElement(Input, null)
  }));
});
var _StyledSelect = _styled("select").withConfig({
  displayName: "Input___StyledSelect",
  componentId: "sc-1njatub-8"
})(["", " -webkit-appearance:none;border-radius:0px;&:valid{", "}", ""], baseInputStyle, hasValue, baseInputPsuedoStyle);
var _StyledSelectArrows = _styled(SelectArrows).withConfig({
  displayName: "Input___StyledSelectArrows",
  componentId: "sc-1njatub-9"
})(["margin-left:-28px;color:", ";"], function (p) {
  return p.$_css3;
});